import { reportConstants } from '../../../../constants/reports';

export const historyListMap = [
	{
		label: reportConstants.REPORT_CREATED,
		value: reportConstants.COLUMN_CREATE_TIME,
		showSort: true,
		sortType: 'date',
	},
	{
		label: reportConstants.REPORT_TRANSACTION_ID,
		value: reportConstants.COLUMN_TRANSACTION_ID,
		showSort: true,
		sortType: 'number',
	},
	{
		label: reportConstants.REPORT_CAMPAIN_ID,
		value: reportConstants.COLUMN_CAMPAIN_ID,
		showSort: true,
		sortType: 'number',
	},
	{
		label: reportConstants.REPORT_CAMPAIN_NAME,
		value: reportConstants.COLUMN_NAME,
		showSort: true,
		sortType: 'string',
	},
	{
		label: reportConstants.REPORT_AMOUNT_AWARDED,
		value: reportConstants.COLUMN_AMOUNT_AWARDED,
		showSort: true,
		sortType: 'number',
	},
	{
		label: reportConstants.REPORT_REMAINING_AMOUNT,
		value: reportConstants.COLUMN_REMAINING_AMOUNT,
		showSort: true,
		sortType: 'number',
	},
	{
		label: reportConstants.REPORT_REMAINING_WAGERING,
		value: reportConstants.COLUMN_REMAINING_WAGERING,
		showSort: true,
		sortType: 'number',
	},
	{
		label: reportConstants.REPORT_EXPIRATION,
		value: reportConstants.COLUMN_EXPIRATION,
		showSort: true,
		sortType: 'date',
	},
];
